import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
    ITEM_ROUTING_OPTION_FIELD_NAME,
    ITEM_TYPES_FIELD_NAME,
    PRODUCT_CATEGORY_IDS_FIELD_NAME,
    RoutingRuleItemRoutingOption,
    SERVICE_FIELD_NAME,
} from '@mews-commander/routing-rules';
import { ApplicationState } from '@mews-commander/types';
import { SpacingLargeLeft, SpacingMediumTop } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { RoutedItemType } from '@mews-commander/data-access';
import { Option } from '@mews-commander/legacy-data-structures';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { CheckboxGroupField, SelectField } from '@mews-commander/legacy-form';
import { getProductCategoriesOptions } from '../selectors';

const ServiceItemRoutingSection = ({ routeSelectedItems, productCategoriesOptions, timeUnitKey }: $TSFixMe) => (
    <>
        {routeSelectedItems ? (
            <SpacingLargeLeft>
                <SpacingMediumTop />
                <CheckboxGroupField {...getItemTypesProps(timeUnitKey)} />
                <SpacingMediumTop />
                <SelectField {...stayProductsProps} options={productCategoriesOptions} />
            </SpacingLargeLeft>
        ) : null}
    </>
);

const getItemTypesProps = (timeUnitKey: $TSFixMe) => ({
    label: <LocalizedText textKey={TextKey.StayItemPlural} />,
    name: ITEM_TYPES_FIELD_NAME,

    options: [
        Option({
            name: ITEM_TYPES_FIELD_NAME,
            value: RoutedItemType.SpaceOrder,
            label: <LocalizedText textKey={timeUnitKey} />,
        }),
        Option({
            name: ITEM_TYPES_FIELD_NAME,
            value: RoutedItemType.CityTax,
            label: <LocalizedText textKey={TextKey.CityTax} />,
        }),
    ],
});

const stayProductsProps = {
    label: <LocalizedText textKey={TextKey.StayProductCategoryPlural} />,
    name: PRODUCT_CATEGORY_IDS_FIELD_NAME,
    multiselect: true,
    hint: <LocalizedText textKey={TextKey.RoutingRuleProductCategoriesHint} />,
};

export default connect((state: ApplicationState, { form }: { form: string }) => {
    const formSelector = formValueSelector(form);
    const itemRoutingOption = formSelector(state, ITEM_ROUTING_OPTION_FIELD_NAME);
    const serviceId = formSelector(state, SERVICE_FIELD_NAME);

    return {
        routeSelectedItems: itemRoutingOption === RoutingRuleItemRoutingOption.OnlySelected,
        productCategoriesOptions: getProductCategoriesOptions(state, { serviceId }),
        timeUnitKey: getServiceTimeUnitPluralKey(state, { id: serviceId }),
    };
})(ServiceItemRoutingSection);
